import { Command as CommandPrimitive } from "cmdk";
import { type ComponentProps } from "react";

import { cn } from "../../utils";

export type CommandSeparatorProps = ComponentProps<typeof CommandPrimitive.Separator>;

const Separator = ({ ref, className, ...props }: CommandSeparatorProps) => (
  <CommandPrimitive.Separator ref={ref} className={cn("my-1 h-px bg-neutral-96", className)} {...props} />
);

Separator.displayName = CommandPrimitive.Separator.displayName;

export default Separator;
